import { DocumentData } from "firebase/firestore";
import { GridElement } from "../../../types/gridElement";
import { beforeWrapper, borderSettings } from "../../../utils";

export const PlPlansInputCostRatio = ({
  headerTitle,
  title,
  rows,
  headers,
  field,
  descriptions,
}: {
  headerTitle?: string;
  title?: string;
  rows: DocumentData[];
  headers: DocumentData[];
  field: string;
  descriptions: DocumentData;
}) => {
  const grid: GridElement[][] = [];

  const gridRow0: GridElement[] = [
    {
      value: headerTitle,
      readOnly: true,
      className: `${beforeWrapper} left-0 p-4px bg-white before:border-b text-16px font-bold z-[32]`,
      colSpan: 4,
    },
    {
      value: "",
      readOnly: true,
      className: `${beforeWrapper} left-0 p-4px bg-white before:border-b`,
      colSpan: 1 + (headers?.length ?? 0),
    },
  ];
  grid.push(gridRow0);

  rows.map((row, index) => {
    // className
    const classCol1 = `${beforeWrapper} left-0 pl-4px bg-white ${
      rows.length === index + 1 && "before:border-b"
    } before:border-l align-top`;

    const classCol2 = `${beforeWrapper} ${
      title ? "left-80px" : "left-0"
    }  p-4px bg-white before:border-b before:border-x ${
      title && "before:border-l-c3333334d"
    } before:border-r-c3333334d ${
      rows.length !== index + 1 && "before:border-b-c3333334d"
    } ${index % 2 !== 0 && "before:bg-c2a4b770d"}`;

    const classCol3 = `${borderSettings} ${
      rows.length !== index + 1 && "before:border-b-c3333334d"
    } text-right `;

    const classCol5 = `${borderSettings}  before:border-x before:border-b before:border-l-c3333334d ${
      rows.length !== index + 1 && "before:border-b-c3333334d"
    } ${index % 2 !== 0 && "bg-c2a4b770d"} h-50px description`;

    const gridRow: GridElement[] = [];

    gridRow.push({
      value: index === 0 && title,
      readOnly: true,
      className: `${classCol1}`,
      colSpan: 2,
    });

    gridRow.push({
      value: row.item,
      readOnly: true,
      className: `${classCol2}`,
      colSpan: title ? 2 : 4,
    });

    headers?.map((header) => {
      // オブジェクトの中から該当する値を取得
      const resultsAndPlanTerm = row[field];

      type TypeOfResultObj = typeof resultsAndPlanTerm;
      const key: keyof TypeOfResultObj = header.period;

      gridRow.push({
        value:
          row[`${field}_cost_ratio`] &&
          row[`${field}_cost_ratio`][header.period]
            ? `${row[`${field}_cost_ratio`][header.period]}%`
            : "0%",
        expr:
          row[`${field}_cost_ratio`] &&
          row[`${field}_cost_ratio`][header.period]
            ? row[`${field}_cost_ratio`][header.period]
            : 0,
        readOnly: false,
        className: `${classCol3} ${
          !header.isTotal && index % 2 !== 0 && "bg-c2a4b770d"
        } ${header.isTotal && "bg-cfffee2"}`,
        row: row,
        url: `${field}_cost_ratio`,
        key: key as string,
      });
    });

    gridRow.push({
      value: descriptions[`${field}${index}`],
      readOnly: false,
      className: `${classCol5}`,
      field: `${field}${index}`,
      key: "descriptions_calc",
      row: descriptions,
    });
    grid.push(gridRow);
  });

  return grid;
};
